import React, { useState } from "react";
import baseUrl from "../../../api/universalApi";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import axios from "axios";

const InvoiceView = ({ campaign, contract, setIsInvoice, setPopup }) => {
  const campaignData = campaign[0];
  //console.log("cam", campaignData)
 // console.log("link", campaignData?.invoice?.invoice_file)
  const [invoice, setInvoice] = useState(null);
  const user = useSelector((state) => state.auth?.authData?.user);

  //console.log("in ", initialData);
  const [formData, setFormData] = useState({
    campaignData: campaign[0] || {},

    contract: contract || {},
    invoice_file: null,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox" ? checked : type === "file" ? files[0] : value,
    }));
  };

  const handleSendInvoice = async (e) => {
    e.preventDefault();
    try {
      const filedata = new FormData();
      if (formData?.invoice_file) {
        const fileName = Date.now() + formData?.invoice_file.name;
        filedata.append("name", fileName);
        filedata.append("file", formData.invoice_file);
      }
      filedata.append("campaignData", JSON.stringify(formData?.campaignData));
      filedata.append("contract", JSON.stringify(formData?.contract));

      const response = await axios.post(
        `${baseUrl}/api/agreement/sendInvoice`,
        filedata,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data?.success) {
        toast.success("Invoice sent successfully!");
        setIsInvoice(false);
      } else {
        toast.error(
          "Failed to send invoice: " +
            (response.data?.message || "Unknown error")
        );
      }
    } catch (error) {
      console.error("Error sending invoice:", error);
      toast.error("Error sending invoice");
    }
  };

  return (
    <div className=" w-full mx-auto   bg-white text-sm md:text-base">
      <div className="flex flex-row gap-4 ">
        <div className="mb-6 border-b pb-4">
          <h1 className="text-2xl font-bold">Invoice</h1>
          <p className="text-gray-500">
            Campaign: {campaignData?.campaignTitle || "N/A"}
          </p>
          <p className="text-gray-500">Platform: {campaignData?.platform}</p>
          <p className="text-gray-500">Brand: {campaignData?.brandName}</p>
          <p className="text-gray-500">Status: {campaignData?.status}</p>
          <p className="text-gray-500">
            Created At: {new Date(campaignData?.createdAt).toLocaleString()}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <h2 className="text-xl font-semibold mb-2">Contract Details</h2>
            <p>
              Publish Date: {new Date(contract.publish_date).toLocaleString()}
            </p>
            <p>Start Date: {new Date(contract.start_date).toLocaleString()}</p>
            <p>End Date: {new Date(contract.end_date).toLocaleString()}</p>
            <p>Company Name: {contract.company}</p>
            <p>Payment Type: {contract.paymentType}</p>
            <p>Final Amount: ₹{contract.amount}</p>
            <p>Deliverables: {contract.deliverables}</p>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-2">Signatures</h2>
            <p>Creator Signature: {contract.creator_signature}</p>
            <p>Brand Signature: {contract.rep_signature}</p>
            <p>Brand Email: {contract.rep_email}</p>
          </div>
        </div>
      </div>

        {campaignData?.invoice?.invoice_file && (
          <>
            <div>
             
              <a href={campaignData?.invoice?.invoice_file} target="_blank">
                Current Invoice file
              </a>
            </div>
          </>
        )}

      <form
        onSubmit={handleSendInvoice}
        className="flex w-1/2 items-start mt-2 font-bold"
        encType="multipart/form-data"
      >
        <label className="block text-md font-start">
          Upload Invoice (PDF)
        </label>
        <input
          type="file"
          name="invoice_file"
          accept="application/pdf"
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
        />

      
      </form>

      {user?.userType === "Influencer" ? (
        <button
          onClick={handleSendInvoice}
          className="bg-blue-600 text-white px-6 py-2 rounded-xl hover:bg-blue-700 transition w-full md:w-auto"
        >
          Send Invoice
        </button>
      ) : (
        <button
          onClick={() => setPopup(false)}
          className="bg-gray-300 text-gray-700 px-6 py-2 rounded-xl hover:bg-gray-400 transition w-full md:w-auto"
        >
          Close
        </button>
      )}
    </div>
  );
};

export default InvoiceView;
